import React from "react";
import { useI18n } from "../i18n/I18nContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Languages, Check } from "lucide-react";

const FLAGS = { it: "🇮🇹", en: "🇬🇧", de: "🇩🇪", es: "🇪🇸", fr: "🇫🇷", ja: "🇯🇵" };
const LABELS = { it: "Italiano", en: "English", de: "Deutsch", es: "Español", fr: "Français", ja: "日本語" };

export default function LanguageSwitcher({ variant = "header" }) {
  const { lang, setLang, supported, t } = useI18n();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher-btn"
          className={
            variant === "header"
              ? "inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium text-mabw-soft hover:bg-stone-100 transition-colors"
              : "inline-flex items-center gap-1.5"
          }
          aria-label={t("lang.label")}
        >
          <Languages className="w-4 h-4" />
          <span className="uppercase tracking-wider">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        <DropdownMenuLabel>{t("lang.label")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {supported.map((code) => (
          <DropdownMenuItem
            key={code}
            data-testid={`lang-option-${code}`}
            onClick={() => setLang(code)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="text-base leading-none">{FLAGS[code]}</span>
            <span className="flex-1">{LABELS[code]}</span>
            {lang === code && <Check className="w-4 h-4 text-mabw-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
